module.exports = __webpack_public_path__ + "static/img/雾.6bbb3ac0.svg";